import { useState, useEffect } from "react";

// ⚠ `turnosApi` se importa DINÁMICO, no arriba. Este hook lo usa
// `layout/MainListItems`, que está en el bundle PRINCIPAL: un `import`
// estático arrastra un módulo de TurnosIA a la evaluación del bundle, y un
// error a nivel de módulo ahí NO lo atrapa ningún error boundary — React ni
// llega a montar y la pantalla queda EN BLANCO. Verificado el 24-09-2026
// inyectando un `throw` en `useTurnosApi.js`: WAIA entera en blanco, `#root`
// sin hijos. Con el import dentro del effect, el mismo `throw` cae en el
// `.catch()` de abajo y el único efecto es que Chats no aparece.

// Acceso a la sección Chats para perfiles profesional/agendador = SOLO en la versión
// full de TurnosIA: plan turnos_chat/enterprise + modo de operación con_chat.
// Consulta GET /company/operation-mode una vez por sesión (cache a nivel módulo,
// patrón useTerminology). Default DENY hasta que carga → el candado no se debilita.
const FULL_PLANS = ["turnos_chat", "enterprise"];
let cache = { loaded: false, enabled: false, promise: null };

export function invalidateTurnosChatAccess() {
  cache = { loaded: false, enabled: false, promise: null };
}

export default function useTurnosChatAccess(user) {
  const relevant =
    !!user && (user.profile === "profesional" || user.profile === "agendador");
  const [state, setState] = useState({ loaded: cache.loaded, enabled: cache.enabled });

  useEffect(() => {
    if (!relevant) return undefined;
    if (cache.loaded) {
      setState({ loaded: true, enabled: cache.enabled });
      return undefined;
    }
    if (!cache.promise) {
      cache.promise = import("../pages/TurnosIA/hooks/useTurnosApi")
        .then(({ turnosApi }) => turnosApi.get("/company/operation-mode"))
        .then(({ data }) => {
          const full =
            FULL_PLANS.includes(data?.plan) && data?.operationMode === "con_chat";
          cache.loaded = true;
          cache.enabled = full;
          return full;
        })
        .catch(() => {
          cache.loaded = true;
          cache.enabled = false;
          return false;
        });
    }
    let alive = true;
    cache.promise.then((en) => {
      if (alive) setState({ loaded: true, enabled: en });
    });
    return () => {
      alive = false;
    };
  }, [relevant]);

  return state; // { loaded, enabled }
}
